import styled from 'styled-components';
import { H4, colors, spacing } from 'ui/theme';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { pxToRem } from 'utils/convert';

export const StyledFixedWidth = styled(FixedWidth)`
  display: grid;
  gap: ${spacing.double};
  grid-template-columns: 1fr;
  /* Hack adds to 14px padding top to make around 32px */
  padding-top: ${spacing.plusQuarter};
  padding-bottom: ${spacing.x5};

  @media (min-width: 1200px) {
    grid-template-columns: ${pxToRem(320)} 1fr;
  }
`;

export const TextWrapper = styled.div``;

export const SettingsWrapper = styled.div``;

export const Card = styled.div`
  padding: ${spacing.plusHalf};
  background-color: ${colors.white};
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};

  & + & {
    margin-top: ${spacing.double};
  }
`;

export const StyledHeader = styled(H4)`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing.base};
  width: 100%;
  padding: ${spacing.base} ${spacing.layoutLRPadding};
  background-color: ${colors.white};
  border-top: ${spacing.single} solid ${colors.borderPrimary};
`;
